<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>

        <v-card class="text-xs-center" v-if="administrador === true">

          <!-- Título da página -->
          <basic-toolbar :title="'Aprovar, devolver para o coordenador ou reprovar relatórios técnicos aguardando aprovação'"></basic-toolbar>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
          </v-card-title>

          <v-card-text>

            <!-- Tabela com os relatórios técnicos aguardando aprovação -->
            <v-data-table
            :headers="headers"
            :items="listaRelatorios"
            :search="search"
            :no-data-text="'Nenhum relatório encontrado'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >

              <!-- Link para a tela de visualização do relatório -->    
              <template v-slot:item.id="props">
                <router-link :to="{ name: 'RelatorioTecnico', params: { idProjeto: props.item.numeroAcaoExtensao, idRelatorioExtensao: props.item.id }}">
                  Relatório {{ props.item.ordem }}
                </router-link>
              </template>

              <!-- Formata a data inicial do relatório -->
              <template v-slot:item.dtInicial="props">{{dates.format(props.item.dtInicial)}}</template>

              <!-- Formata a data final do relatório -->
              <template v-slot:item.dtFinal="props">{{dates.format(props.item.dtFinal)}}</template>

              <!-- Formata o tipo do relatório -->
              <template v-slot:item.tipoRelatorioTecnicoItem="props">
                {{
                props.item.tipoRelatorioTecnicoItem === 1 ? "Relatório Parcial" :
                props.item.tipoRelatorioTecnicoItem === 2 ? "Relatório Parcial com Renovação" :
                props.item.tipoRelatorioTecnicoItem === 3 ? "Relatório Final" : "Tipo Inválido"
                }}
              </template>

              <!-- Formata a situação do relatório -->
              <template v-slot:item.situacaoRelatorioTecnicoItem="props">
                {{
                props.item.situacaoRelatorioTecnicoItem === 1 ? "Em elaboração" :
                props.item.situacaoRelatorioTecnicoItem === 2 ? "Aguardando aprovação" :
                props.item.situacaoRelatorioTecnicoItem === 3 ? "Aprovado" :
                props.item.situacaoRelatorioTecnicoItem === 4 ? "Reprovado" : "Situação inválida"
                }}
              </template>

              <!-- Ícones da coluna "Opções" -->
              <template v-slot:item.opcoes="props">

                <!-- Ícone de aprovar -->
                <c-tooltip-btn
                v-if="usuarioAdministrador()"
                icon="done_outline"
                color="green"
                tooltip="Aprovar"
                @click="toAprovar(props.item.numeroAcaoExtensao, props.item.id)"
                ></c-tooltip-btn>

                <!-- Ícone de devolver -->
                <c-tooltip-btn
                v-if="usuarioAdministrador()"
                icon="not_interested"
                color="red"
                tooltip="Devolver"
                @click="toDevolver(props.item.numeroAcaoExtensao, props.item.id)"
                ></c-tooltip-btn>

                <!-- Ícone de reprovar -->
                <c-tooltip-btn
                v-if="usuarioAdministrador()"
                icon="cancel"
                color="black"
                tooltip="Reprovar"
                @click="toReprovar(props.item.numeroAcaoExtensao, props.item.id)"
                ></c-tooltip-btn>

              </template>
              
              <!-- Texto de rodapé que informa a quantidade de relatórios -->
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaRelatorios.length }} relatórios
              </template>

            </v-data-table>

            <br>

          </v-card-text>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import TootipButton from '@/components/c-tooltip-btn'
  import DataMenu from '@/components/c-date-menu'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      formularioValido: false,
      dates: dates,
      listaRelatorios: [],
      pesquisa: {
        situacao: 2 // Aguardando aprovação
      },
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
      { text: 'Número da ação', align: 'left', value: 'numeroAcaoExtensao' },
      { text: 'Título da ação', align: 'left', value: 'tituloAcaoExtensao' },
      { text: 'Coordenador', align: 'left', value: 'nomeCoordenador' },
      { text: 'Relatório', align: 'left', value: 'id' },
      { text: 'Tipo do relatório', align: 'left', value: 'tipoRelatorioTecnicoItem' },
      { text: 'Início', align: 'left', value: 'dtInicial' },
      { text: 'Fim', align: 'left', value: 'dtFinal' },
      { text: 'Situação do relatório', align: 'left', value: 'situacaoRelatorioTecnicoItem' },
      { text: 'Opções', align: 'left', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      // Busca os relatórios técnicos aguardando aprovação.
      pesquisarRelatoriosTecnicosAguardandoAprovacao () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios.' })
        projetos.getConsultaRelatoriosTecnicos(this.pesquisa)
        .then(response => {
          this.listaRelatorios = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.listaRelatorios = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatórios.' })
        })
      },
      // Verifica se o usuário logado é administrador.
      usuarioAdministrador: function () {
        if (this.administrador === true) {
          return true
        } else {
          return false
        }
      },
      // Redireciona para a página de aprovação de um relatório técnico.
      toAprovar: function (idProjeto, idRelatorioExtensao) {
        this.$router.push({ name: 'AprovarRelatorio', params: {idProjeto: idProjeto, idRelatorio: idRelatorioExtensao} })
      },
      // Redireciona para a página de devolução de um relatório técnico.
      toDevolver: function (idProjeto, idRelatorioExtensao) {
        this.$router.push({ name: 'DevolverRelatorio', params: {idProjeto: idProjeto, idRelatorio: idRelatorioExtensao} })
      },
      // Redireciona para a página de reprovação de um relatório técnico.
      toReprovar: function (idProjeto, idRelatorioExtensao) {
        this.$router.push({ name: 'ReprovarRelatorio', params: {idProjeto: idProjeto, idRelatorio: idRelatorioExtensao} })
      }
    },
    mounted () {
      // Busca os relatórios técnicos aguardando aprovação.
      this.pesquisarRelatoriosTecnicosAguardandoAprovacao()
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-tooltip-btn': TootipButton,
      'c-date-menu': DataMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// relatorios-aprovar-tabela.vue?02d41d59